export default __webpack_public_path__ + "static/media/logoSISblue2.240a271b.png";